import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router } from 'react-router-dom';
const root = document.getElementById('root');
if (!root) throw new Error('No root element found');

// Verify SDK script has loaded (browser guarantees regular scripts execute before module scripts)
if (!window.ScLoan) {
  console.error(
    'ScLoan SDK is not available. Make sure the SDK script tag is present in index.html before the module script.',
  );
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [],
  environment: import.meta.env.MODE,
});

createRoot(root).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);
